<!-- The datasets page is formatted using vue-simple-accordion -->
<!-- Ref link for vue-simple-accordion: https://developer.aliyun.com/mirror/npm/package/vue-simple-accordion/v/0.0.1?spm=a2c6h.14275010.0.0.5b183b77r1qw2f&file=0.0.1 -->
<template>
    <div>
        <h1>Datasets</h1>
        <body>
        <div class="indented">
            NEURON uses 2 datasets namely, TPC-H and IMDb. These datasets have been loaded in the PostgreSQL RDBMS on the NEURON server. Details of these datasets are given below<br /><br />
        </div>
        <vsa-list>
            <vsa-item>
                <vsa-heading>
                    TPC-H
                </vsa-heading>
                <vsa-content>
                    <div class="indented">
                        The <a href="http://www.tpc.org/tpch/" active target="_blank">TPC Benchmark</a> (TPC-H) is a decision support benchmark consisting of a suite of business oriented ad-hoc
                        queries and concurrent data modifications. The queries and data in TPC-H have been chosen to have broad industry-wide relevance. Further details on creating a TPC-H on
                        PostgreSQL DB and TPC-H queries that have been modified to run in PostgreSQL can be found <a href="http://myfpgablog.blogspot.com/2016/08/tpc-h-queries-on-postgresql.html" active target="_blank">here</a>.
                    </div>
                </vsa-content>
            </vsa-item>
            <vsa-item>
                <vsa-heading>
                    IMDb
                </vsa-heading>
                <vsa-content>
                    <div class="indented">
                        <a href="https://www.imdb.com/interfaces/" active target="_blank">IMDb (Internet Movie Database)</a> is an online database related to films, television programs, home videos,
                        video games and streaming content. It includes information on cast, production crew and personal biographies, plot summaries, trivia, ratings, and fan and critical reviews. The following
                        tools may be useful for extracting the IMDb data: <a href="http://www.jmdb.de/" active target="_blank">Java Movie Database</a>(suggested
                        <a href="http://www.jmdb.de/content/eng/dbschema/dbschema.html" active target="_blank">schema</a>) and <a href="https://imdbpy.github.io/" active target="_blank">IMDbPY</a>
                    </div>
                </vsa-content>
            </vsa-item>
        </vsa-list>
        <!-- router -->
        <router-view></router-view>
        </body>
    </div>
</template>
<script>
import {
  VsaList,
  VsaItem,
  VsaHeading,
  VsaContent
} from 'vue-simple-accordion';
//import '@/assets/css/vue-simple-accordion.css';
import 'vue-simple-accordion/dist/vue-simple-accordion.css';
export default {
  name: "Datasets",
  components: {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent
  }
}
</script>